import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { myListsEditListFormStyles } from "@insite/content-library/Widgets/MyLists/MyListsEditListForm";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

myListsEditListFormStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
        :hover {
            opacity: 0.3;
            border-color: ${getColor("text.main")} !important;
        }
    `,
};

myListsEditListFormStyles.createButton = mergeToNew(myListsEditListFormStyles.createButton, {
    css: css`
        &:hover {
            background: ${getColor("text.accent")};
            span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
            }
        }
    `,
});
